import React, { useState, useContext } from 'react';
import Modal from 'react-modal';
import { storage } from '../config/firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { AuthContext } from '../config/AuthProvider';
import '../css/PersonForm.css';

function PersonForm({ onAddPerson, firms }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { currentUser } = useContext(AuthContext);

  const [name, setName] = useState('');
  const [email, setEmail] = useState(''); // Novo stanje za email
  const [city, setCity] = useState(''); // Novo stanje za grad
  const [comment, setComment] = useState(''); // Novo stanje za komentar
  const [nationality, setNationality] = useState('Hrvat');
  const [fee, setFee] = useState(0);
  const [appKnjig, setAppKnjig] = useState(0);
  const [doprinosi, setDoprinosi] = useState(0);
  const [extraDoprinosi, setExtraDoprinosi] = useState(0);
  const [renta, setRenta] = useState(0);
  const [rentSmjestaj, setRentSmjestaj] = useState(0);
  const [oprema, setOprema] = useState(0);
  const [akontacija, setAkontacija] = useState(0);
  const [gorivo, setGorivo] = useState(0);
  const [ostalo, setOstalo] = useState(0);
  const [bonus, setBonus] = useState(0);
  const [tekuciRacun, setTekuciRacun] = useState('');
  const [zasticeniRacun, setZasticeniRacun] = useState('');
  const [riderID, setRiderID] = useState(''); // Rider ID - obavezno polje
  const [firmId, setFirmId] = useState('default');

  // New state variables for foreigners
  const [tarifa, setTarifa] = useState(0);
  const [depozit, setDepozit] = useState(0);
  const [struja, setStruja] = useState(0);
  const [glovoTax, setGlovoTax] = useState(0);

  const [startMonth, setStartMonth] = useState(new Date().getMonth() + 1);
  const [startYear, setStartYear] = useState(new Date().getFullYear());
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    // Resetiranje form stanja
    setName('');
    setEmail('');
    setCity(''); // Resetiranje city polja
    setComment(''); // Resetiranje comment polja
    setNationality('Hrvat');
    setFee(0);
    setAppKnjig(0);
    setDoprinosi(0);
    setExtraDoprinosi(0);
    setRenta(0);
    setRentSmjestaj(0);
    setOprema(0);
    setAkontacija(0);
    setGorivo(0);
    setOstalo(0);
    setBonus(0);
    setTekuciRacun('');
    setZasticeniRacun('');
    setRiderID('');
    setFirmId('default');
    setTarifa(0);
    setDepozit(0);
    setStruja(0);
    setGlovoTax(0);
    setImageFile(null);
    setImagePreview(null);
    setModalIsOpen(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Provjera tipa datoteke
      if (!file.type.startsWith('image/')) {
        alert('Molimo odaberite sliku.');
        return;
      }
      // Provjera veličine (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Slika je prevelika. Maksimalna veličina je 5MB.');
        return;
      }
      setImageFile(file);
      // Kreiranje preview-a
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Funkcija za sanitizaciju imena datoteke
  const sanitizeFileName = (fileName) => {
    // Ukloni sve posebne znakove osim slova, brojeva, točke i crtice
    return fileName.replace(/[^a-zA-Z0-9.-]/g, '_');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let imageUrl = null;

    // Upload slike ako postoji
    if (imageFile) {
      // Provjera autentifikacije
      if (!currentUser) {
        alert('Morate biti prijavljeni da biste uploadali sliku.');
        return;
      }

      setUploadingImage(true);
      try {
        // Sanitiziraj ime datoteke
        const sanitizedFileName = sanitizeFileName(imageFile.name);
        const imageRef = ref(storage, `person-images/${Date.now()}-${sanitizedFileName}`);
        
        await uploadBytes(imageRef, imageFile);
        imageUrl = await getDownloadURL(imageRef);
      } catch (error) {
        console.error('Greška pri upload-u slike:', error);
        console.error('Error details:', error.code, error.message);
        
        let errorMessage = 'Došlo je do greške prilikom upload-a slike.';
        if (error.code === 'storage/unauthorized') {
          errorMessage = 'Nemate dozvolu za upload slike. Provjerite Firebase Storage rules.';
        } else if (error.code === 'storage/canceled') {
          errorMessage = 'Upload je otkazan.';
        } else if (error.code === 'storage/unknown') {
          errorMessage = 'Nepoznata greška. Provjerite da li je Storage omogućen u Firebase Console.';
        }
        
        alert(errorMessage);
        setUploadingImage(false);
        return;
      }
      setUploadingImage(false);
    }

    // Priprema objekta "person" s podacima
    const person = {
      name,
      email,
      city, // Dodavanje city polja
      comment, // Dodavanje comment polja
      nationality,
      fee,
      appKnjig,
      doprinosi,
      extraDoprinosi,
      renta,
      rentSmjestaj,
      oprema,
      akontacija,
      gorivo,
      ostalo,
      bonus,
      tekuciRacun,
      zasticeniRacun,
      riderID,
      firmId,
      startMonth,
      startYear,
      archived: false,
    };

    // Dodaj imageURL ako postoji
    if (imageUrl) {
      person.imageUrl = imageUrl;
    }

    // Ako je nacionalnost "Stranac", dodajemo dodatna polja
    if (nationality === 'Stranac') {
      person.tarifa = tarifa;
      person.depozit = depozit;
      person.struja = struja;
      person.glovoTax = glovoTax;
    }

    // Poziv funkcije iz roditeljske komponente
    onAddPerson(person);
    closeModal();
  };

  return (
    <div>
      <button className="add-person-button" onClick={openModal}>
        Dodaj osobu
      </button>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Dodaj osobu</h2>
        <form onSubmit={handleSubmit} className="person-form">
          <div className="form-group">
            <label>Ime:</label>
            <input
              type="text"
              placeholder="Ime"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Grad:</label>
            <input
              type="text"
              placeholder="Grad"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Komentar:</label>
            <textarea
              placeholder="Komentar o osobi"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows="3"
            />
          </div>
          <div className="form-group">
            <label>Slika osobe:</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
            />
            {imagePreview && (
              <div style={{ marginTop: '10px' }}>
                <img 
                  src={imagePreview} 
                  alt="Preview" 
                  style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '4px' }} 
                />
              </div>
            )}
            {uploadingImage && <p>Upload slike u tijeku...</p>}
          </div>
          <div className="form-group">
            <label>Nacionalnost:</label>
            <select
              value={nationality}
              onChange={(e) => setNationality(e.target.value)}
            >
              <option value="Hrvat">Hrvat</option>
              <option value="Stranac">Stranac</option>
            </select>
          </div>
          <div className="form-group">
            <label>Rider ID:</label>
            <input
              type="text"
              placeholder="Rider ID"
              value={riderID}
              onChange={(e) => setRiderID(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Firma:</label>
            <select
              value={firmId}
              onChange={(e) => setFirmId(e.target.value)}
              required
            >
              {firms.map((firm) => (
                <option key={firm.id} value={firm.id}>
                  {firm.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Fee %:</label>
            <input
              type="number"
              placeholder="Fee %"
              value={fee}
              onChange={(e) => setFee(parseFloat(e.target.value))}
              required
            />
          </div>
          <div className="form-group">
            <label>App Knjig.:</label>
            <input
              type="number"
              placeholder="App Knjig."
              value={appKnjig}
              onChange={(e) => setAppKnjig(parseFloat(e.target.value))}
              required
            />
          </div>
          <div className="form-group">
            <label>Doprinosi:</label>
            <input
              type="number"
              placeholder="Doprinosi"
              value={doprinosi}
              onChange={(e) => setDoprinosi(parseFloat(e.target.value))}
              required
            />
          </div>
          <div className="form-group">
            <label>Extra doprinosi:</label>
            <input
              type="number"
              placeholder="Extra doprinosi"
              value={extraDoprinosi}
              onChange={(e) => setExtraDoprinosi(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Renta (default):</label>
            <input
              type="number"
              value={renta}
              onChange={(e) => setRenta(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Rent smještaj (default):</label>
            <input
              type="number"
              value={rentSmjestaj}
              onChange={(e) => setRentSmjestaj(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Akontacija (default):</label>
            <input
              type="number"
              value={akontacija}
              onChange={(e) => setAkontacija(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Gorivo (default):</label>
            <input
              type="number"
              value={gorivo}
              onChange={(e) => setGorivo(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Ostalo (default):</label>
            <input
              type="number"
              value={ostalo}
              onChange={(e) => setOstalo(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Bonus (default):</label>
            <input
              type="number"
              value={bonus}
              onChange={(e) => setBonus(parseFloat(e.target.value) || 0)}
            />
          </div>
          {nationality === 'Stranac' && (
            <>
              <div className="form-group">
                <label>Tarifa (default):</label>
                <input
                  type="number"
                  value={tarifa}
                  onChange={(e) => setTarifa(parseFloat(e.target.value) || 0)}
                />
              </div>

              <div className="form-group">
                <label>Struja (default):</label>
                <input
                  type="number"
                  value={struja}
                  onChange={(e) => setStruja(parseFloat(e.target.value) || 0)}
                />
              </div>
              <div className="form-group">
                <label>Overtime Tax (default):</label>
                <input
                  type="number"
                  value={glovoTax}
                  onChange={(e) => setGlovoTax(parseFloat(e.target.value) || 0)}
                />
              </div>
            </>
          )}
          <div className="form-group">
            <label>Tekući račun:</label>
            <input
              type="text"
              placeholder="Tekući račun"
              value={tekuciRacun}
              onChange={(e) => setTekuciRacun(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Zaštićeni račun:</label>
            <input
              type="text"
              placeholder="Zaštićeni račun"
              value={zasticeniRacun}
              onChange={(e) => setZasticeniRacun(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Početni mjesec:</label>
            <select value={startMonth} onChange={(e) => setStartMonth(parseInt(e.target.value))}>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Početna godina:</label>
            <select value={startYear} onChange={(e) => setStartYear(parseInt(e.target.value))}>
              {Array.from({ length: new Date().getFullYear() + 1 - 2022 + 1 }, (_, i) => 2022 + i).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
          <div className="button-group">
            <button type="submit" className="save-button">
              Spremi
            </button>
            <button type="button" onClick={closeModal} className="cancel-button">
              Odustani
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default PersonForm;
